import * as React from 'react';

const SVGIllustration404: React.SFC<SvgProps> = props => (
    <svg width={600} height={353} {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                stroke="#9BC3D3"
                d="M16.093 320.077h146.232V173.845H16.093z"
            />
            <path
                stroke="#9BC3D3"
                d="M16.093 190.077h146.232v-16.232H16.093zm0 0l146.232 130m-146.232 0l146.232-130"
            />
            <path
                stroke="#9BC3D3"
                d="M589.323 246.5h-264c-5.523 0-10-4.477-10-10v-200h284v200c0 5.523-4.477 10-10 10z"
            />
            <path
                stroke="#9BC3D3"
                d="M599.323 36.5h-284v-26c0-5.523 4.477-10 10-10h264c5.523 0 10 4.477 10 10v26z"
            />
            <path
                fill="#9BC3D3"
                d="M344.323 18.5a9 9 0 01-9 9 9 9 0 01-9-9 9 9 0 019-9 9 9 0 019 9"
            />
            <path
                fill="#FC3"
                d="M372.323 18.5a9 9 0 01-9 9 9 9 0 01-9-9 9 9 0 019-9 9 9 0 019 9"
            />
            <path
                fill="#C3DEE7"
                d="M400.323 18.5a9 9 0 01-9 9 9 9 0 01-9-9 9 9 0 019-9 9 9 0 019 9"
            />
            <path fill="#DEEDF2" d="M197.209 352.717h134.05v-8.696h-134.05z" />
            <path
                fill="#DEEDF2"
                d="M267.126 352.717h-90.791c-4.237 0-6.553-4.94-3.844-8.197l73.544-88.43h101.452l-80.361 96.627z"
            />
            <path
                fill="#9BC3D3"
                d="M304.724 307.485l-73.738-33.335 101.512-.046z"
            />
            <path
                fill="#DEEDF2"
                d="M436.06 274.927H128.386c-5.523 0-10-4.479-10-10V79.177c0-5.523 4.477-10 10-10H436.06c5.523 0 10 4.477 10 10v185.75c0 5.521-4.477 10-10 10"
            />
            <path
                fill="#9BC3D3"
                d="M17.721 113.727h145.813v-8.464H17.721zm-17.721 0h7.813v-8.464H0z"
            />
            <path
                fill="#DEEDF2"
                d="M513.653 352.427h-47.967c-4.662 0-8.44-5.466-8.44-10.128v-65.836h64.847v65.836c0 4.662-3.778 10.129-8.44 10.129"
            />
            <path
                fill="#DEEDF2"
                d="M521.816 340.611v-5.026c10.53 0 16.565-8.729 16.565-18.517 0-9.789-6.034-18.518-16.565-18.518v-5.026c14.055 0 26.334 10.562 26.334 23.544 0 12.981-12.28 23.543-26.334 23.543"
            />
            <path
                fill="#F2F8FA"
                d="M550.092 192.057c-49.8 57.397-50.608 84.405-50.608 84.405h-18.005s3.79-41.163 55.108-106.35c62.46-79.342 15.015-148.572 9.284-159.526 0 0 103.217 67.374 4.22 181.471"
            />
            <path
                fill="#C3DEE7"
                d="M459.072 276.463h-1.826v65.836c0 4.662 3.779 10.129 8.44 10.129h47.968c1.25 0 2.433-.402 3.5-1.07l-58.082-74.895z"
            />
            <path fill="#1BB3BE" d="M457.246 287.435h64.848v-6.752h-64.848z" />
            <path
                fill="#FC3"
                d="M98.936 35.915l-9.472 9.472-9.471-9.472 9.472-9.472z"
            />
            <path
                fill="#FFF"
                d="M206.883 182.942v-41.338c-10.372 13.038-19.016 26.817-25.929 41.338h25.93zm30.67 8.297c-.396 2.963-.84 5.48-1.334 7.557h-11.408v24.594h-17.928v-24.594h-43.856c0-2.964.048-5.68.148-8.15.097-2.468.296-4.938.592-7.408 4.05-10.173 9.754-20.766 17.114-31.781 7.356-11.013 15.283-21.21 23.78-30.596 3.456-.593 6.667-.986 9.63-1.186 2.964-.196 6.468-.296 10.52-.296v63.563h13.631a153.716 153.716 0 01-.889 8.297zm52.819 14.372c2.222-2.271 3.801-6.05 4.741-11.335.938-5.283 1.407-12.617 1.407-22.002 0-9.383-.469-16.743-1.407-22.076-.94-5.334-2.544-9.187-4.815-11.558-2.274-2.37-5.385-3.555-9.335-3.555-3.95 0-7.037 1.185-9.26 3.555-2.222 2.37-3.829 6.224-4.815 11.558-.989 5.333-1.482 12.693-1.482 22.076 0 9.385.468 16.719 1.408 22.002.937 5.285 2.518 9.064 4.741 11.335 2.222 2.273 5.357 3.407 9.408 3.407 4.05 0 7.186-1.134 9.41-3.407m-36.153 7.26c-5.779-8.691-8.668-22.274-8.668-40.745 0-12.543 1.283-22.792 3.853-30.744 2.567-7.951 6.468-13.802 11.704-17.558 5.235-3.752 11.854-5.63 19.854-5.63 8.098 0 14.742 1.878 19.93 5.63 5.184 3.756 9.06 9.607 11.63 17.558 2.567 7.952 3.851 18.2 3.851 30.744 0 18.47-2.889 32.054-8.667 40.745-5.778 8.693-14.694 13.038-26.744 13.038-12.052 0-20.965-4.345-26.743-13.038m115.64-29.929v-41.338c-10.372 13.038-19.016 26.817-25.93 41.338h25.93zm30.67 8.297c-.396 2.963-.84 5.48-1.334 7.557h-11.408v24.594H369.86v-24.594h-43.856c0-2.964.048-5.68.148-8.15.097-2.468.296-4.938.592-7.408 4.05-10.173 9.754-20.766 17.114-31.781 7.356-11.013 15.283-21.21 23.78-30.596 3.456-.593 6.667-.986 9.63-1.186 2.964-.196 6.468-.296 10.52-.296v63.563h13.63a153.716 153.716 0 01-.888 8.297z"
            />
        </g>
    </svg>
);

export default SVGIllustration404;
